module.exports = __webpack_public_path__ + "img/66c8d71.jpg";